module.exports = __webpack_public_path__ + "img/bb-most-common.ee21a1b.webp";